<div>
    <label>{{propertyName}}</label>
    <div class="input-group">
        <input type="text" 
            #input 
            class="form-control form-control-sm" 
            [ngClass]="{'btn-link cursor-pointer': linked}" 
            [(ngModel)]="propertyValue" 
            [readonly]="!editMode"
            (keydown)="onKeydown($event)" 
            (focusout)="onFocusOut($event)"
            (click)="linked && onClickLink($event)">
        <div *ngIf="editable" class="input-group-append">
            <div *ngIf="!editMode" class="input-group-text cursor-pointer" (click)="onEditClick()" tooltip="Edit {{propertyName}}"><span class="fa fa-edit"></span></div>
            <div *ngIf="editMode" class="input-group-text cursor-pointer" (click)="onEditClick()" tooltip="Save {{propertyName}}"><span class="fa fa-save"></span></div>
        </div>
        <ng-content></ng-content>
    </div>
</div>
